/**
 * bb-referral-capture.js — Bara Bros Referral URL Capture
 *
 * Runs on every page. Detects ?ref=BRO-XXXXXX in the URL, validates
 * the format, and stores it in localStorage for future attribution.
 * Also attempts to set a Shopify cart attribute so server-side code
 * can pick it up on the next order.
 *
 * Fails silently — never throws, never blocks page load.
 */
(function () {
  'use strict';

  var VALID_PREFIX = 'BRO-';
  var CODE_LENGTH  = 10; // "BRO-" (4) + 6 chars = 10 total
  var LS_KEY       = 'bb_referral_code';
  var LS_SEEN_AT   = 'bb_referral_seen_at';

  function isValidCode(code) {
    if (!code || typeof code !== 'string') return false;
    var c = code.trim().toUpperCase();
    if (!c.startsWith(VALID_PREFIX)) return false;
    if (c.length !== CODE_LENGTH) return false;
    return /^[A-Z0-9]+$/.test(c.slice(VALID_PREFIX.length));
  }

  function capture() {
    try {
      var params = new URLSearchParams(window.location.search);
      var raw    = params.get('ref');
      if (!raw) return;

      var code = raw.trim().toUpperCase();
      if (!isValidCode(code)) return;

      // Store in localStorage
      localStorage.setItem(LS_KEY, code);
      localStorage.setItem(LS_SEEN_AT, new Date().toISOString());

      // Attempt to write to Shopify cart attributes — best-effort, non-blocking
      // This lets server-side order processing read the referral code from the cart.
      try {
        fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ attributes: { referral_code: code } })
        }).catch(function () {});
      } catch (e) { /* ignore */ }
    } catch (e) { /* ignore */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', capture);
  } else {
    capture();
  }
})();
